import { GlobalApplicationState } from 'globalApplicationState';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TopicGroup } from 'modules/topics';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import { Button, DialogContent, DialogTitle, Grid, IconButton } from '@mui/material';
import { CloseIcon } from 'tinacms';
import TopicLimitedTextField from '../common/topicLimitedTextField';
import { DEFAULT_FIELD_WIDTH, DEFAULT_LABEL_WIDTH, DIALOG_BODY_PADDING, MAX_TOPIC_NAME_LENGTH } from 'modules/topics/styles/constants';
import MandatoryField from '../common/mandatoryField';
import { editTopicGroup, getTopicGroups, topicSlice } from 'modules/topics/reducer';
import { ThunkDispatch } from '@reduxjs/toolkit';

const TopicGroupRename: React.FunctionComponent<ComponentProps> = (props) => {
    const [name, setName] = React.useState("");

    const { isUpdating: isSaving } = useSelector((state: GlobalApplicationState) => state.topics);
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

    const { errorMessage } = useSelector((state: GlobalApplicationState) => state.topics);

    const handleEdit = async () => {
        if (isSaving) return;
        const isSuccessful = await dispatch(editTopicGroup({ id: props.group.id, name })).unwrap();

        if (isSuccessful) onClose(true);
    };

    const handleFieldChange = (name: string) => {
        setName(name);
        dispatch(topicSlice.actions.SET_ERR_MSG(""));
    }

    const getNameField = (): JSX.Element => {
        return <TopicLimitedTextField
            value={name}
            maxLength={MAX_TOPIC_NAME_LENGTH}
            onChange={handleFieldChange}
            errorText={errorMessage}
        />;
    };

    const onClose = (reload: boolean = false) => {
        setName("");
        dispatch(topicSlice.actions.SET_ERR_MSG(""));
        reload ? dispatch(getTopicGroups()) : props.onClose();
    }

    return (
        <Dialog open={props.show} maxWidth={false} scroll="paper" onClose={() => onClose()} classes={{ paper: "audience-dialog" }}>
            <DialogTitle className="audience-dialog-title">
                Rename Topic Group
                <div className="audience-dialog-actions">
                    <IconButton onClick={() => onClose()} size="medium">
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogTitle>
            <DialogContent className='dialog-content'>
                <Grid container
                    alignItems={"center"}
                    paddingTop={DIALOG_BODY_PADDING}
                    paddingBottom={DIALOG_BODY_PADDING}
                >

                    <Grid item xs={DEFAULT_LABEL_WIDTH}>
                        Rename
                    </Grid>

                    <Grid item xs={DEFAULT_FIELD_WIDTH}>
                        {props.group.name}
                    </Grid>

                </Grid>

                <Grid container
                    alignItems={"center"}
                    paddingTop={DIALOG_BODY_PADDING}
                    paddingBottom={DIALOG_BODY_PADDING}
                >
                    <MandatoryField
                        fieldName="To"
                        fieldInput={getNameField()}
                        fieldStyle={{ marginTop: "10px" }}
                    />
                </Grid>

            </DialogContent>

            <DialogActions className="audience-dialog-footer">
                <Button variant="text" onClick={() => onClose()}> Cancel </Button>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={!name || name.trim().length === 0 || errorMessage !== ""}
                    onClick={handleEdit}
                >
                    Rename
                </Button>
            </DialogActions>
        </Dialog>
    );
};

interface ComponentProps {
    group: TopicGroup;
    show: boolean;
    onClose: () => void;
}

export default TopicGroupRename;